<template>
  <footer class="footer">
    <div class="content">
      <p>
        © Bookman {{ currentYear }}
        <twitter-link twitter-handle="usebookman"/>
        <facebook-link facebook-page-name="usebookman"/>
      </p>
      <p>
        <a @click="goToPrivacyPolicy">Privacy Policy</a> - <a @click="goToTermsOfService">Terms of Service</a>
      </p>
    </div>
</footer>

</template>

<script>
import twitterLink from '@/components/twitter-link'
import facebookLink from '@/components/facebook-link'

export default {
  computed: {
    currentYear () {
      return (new Date()).getFullYear()
    }
  },
  methods: {
    goToPrivacyPolicy () {
      this.$router.push('/privacy')
    },
    goToTermsOfService () {
      this.$router.push('/terms')
    }
  },
  components: {
    facebookLink,
    twitterLink
  }
}
</script>

<style>

</style>
